import { useEvent } from "shared/lib/useEvent"
import { ProductConfigurationFormData } from "shared/types/ProductConfiguration"

import { useProductConfiguratorConfigurationContext } from "./ProductConfiguratorConfigurationContext"

export function useProductConfiguratorConfigurationViewModel() {
  const { schema, formData, isLoading, isDisabled, onFormDataChange } =
    useProductConfiguratorConfigurationContext()

  const handleFormDataChange = useEvent(
    (nextFormData: ProductConfigurationFormData["product"], fieldID?: string) =>
      onFormDataChange({ ...formData, product: nextFormData }, fieldID)
  )
  return {
    id: "product-configurator-product",
    name: "product",
    schema: schema?.properties?.product,
    formData: formData?.product,
    isLoading,
    isDisabled,
    onChange: handleFormDataChange
  }
}
